/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Guidance,
  GuidanceForm,
  GuidanceId,
  GuidancePatch,
  ImprovementHint,
  Intent,
  IntentForm,
  IntentPatch,
  KnowledgeBaseEntry,
  KnowledgeBaseEntryInProcessing,
  KnowledgeEntryImportStatus,
  KnowledgeEntryViaLinkForm,
  MapString,
  PaginatedResultGuidance,
  PaginatedResultIntent,
  PaginatedResultKnowledgeBaseEntry,
  PaginatedResultTestingSession,
  PersonalitySettings,
  PersonalitySettingsPatch,
  PersonalitySettingsView,
  PiperAiStatistics,
  RenderedKnowledgeEntry,
  ResolvedMessageConfig,
  TestMessageForm,
  TestResponseRatingForm,
  TestingSession,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "chat-platform-piper-ai";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Retrieves a specific guidance entry by its ID
   *
   * @tags piper-ai-guidance
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid
   * @summary Get guidance by ID
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/guidance/{guidanceId}
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid = (
    tenantId: string,
    workspaceId: string,
    guidanceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      Guidance,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance/${guidanceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceidPathGetter = (
    tenantId: string,
    workspaceId: string,
    guidanceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance/${guidanceId}`);

  /**
   * @description Deletes a guidance entry by its ID
   *
   * @tags piper-ai-guidance
   * @name DeleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid
   * @summary Delete guidance by ID
   * @request DELETE:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/guidance/{guidanceId}
   * @secure
   */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid = (
    tenantId: string,
    workspaceId: string,
    guidanceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance/${guidanceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceidPathGetter = (
    tenantId: string,
    workspaceId: string,
    guidanceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance/${guidanceId}`);

  /**
   * @description Updates an existing guidance entry by its ID
   *
   * @tags piper-ai-guidance
   * @name PatchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid
   * @summary Update guidance by ID
   * @request PATCH:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/guidance/{guidanceId}
   * @secure
   */
  patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid = (
    tenantId: string,
    workspaceId: string,
    guidanceId: string,
    data: GuidancePatch,
    params: RequestParams = {},
  ) =>
    this.request<
      Guidance,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance/${guidanceId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceid */
  patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidanceGuidanceidPathGetter = (
    tenantId: string,
    workspaceId: string,
    guidanceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance/${guidanceId}`);

  /**
   * @description Returns a paginated list of guidance entries
   *
   * @tags piper-ai-guidance
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidance
   * @summary List guidance entries
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/guidance
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidance = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultGuidance,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidance */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidancePathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance`, query);

  /**
   * @description Creates a new guidance entry
   *
   * @tags piper-ai-guidance
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidance
   * @summary Create new guidance
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/guidance
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidance = (
    tenantId: string,
    workspaceId: string,
    data: GuidanceForm,
    params: RequestParams = {},
  ) =>
    this.request<
      Guidance,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidance */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiGuidancePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/guidance`);

  /**
   * @description Retrieves a specific intent entry by its ID
   *
   * @tags piper-ai-intent
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid
   * @summary Get intent by ID
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/intent/{intentId}
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid = (
    tenantId: string,
    workspaceId: string,
    intentId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      Intent,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent/${intentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentidPathGetter = (
    tenantId: string,
    workspaceId: string,
    intentId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent/${intentId}`);

  /**
   * @description Deletes an intent entry by its ID
   *
   * @tags piper-ai-intent
   * @name DeleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid
   * @summary Delete intent by ID
   * @request DELETE:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/intent/{intentId}
   * @secure
   */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid = (
    tenantId: string,
    workspaceId: string,
    intentId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent/${intentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentidPathGetter = (
    tenantId: string,
    workspaceId: string,
    intentId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent/${intentId}`);

  /**
   * @description Updates an existing intent entry by its ID
   *
   * @tags piper-ai-intent
   * @name PatchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid
   * @summary Update intent by ID
   * @request PATCH:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/intent/{intentId}
   * @secure
   */
  patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid = (
    tenantId: string,
    workspaceId: string,
    intentId: string,
    data: IntentPatch,
    params: RequestParams = {},
  ) =>
    this.request<
      Intent,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent/${intentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentid */
  patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentIntentidPathGetter = (
    tenantId: string,
    workspaceId: string,
    intentId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent/${intentId}`);

  /**
   * @description Returns a paginated list of intent entries
   *
   * @tags piper-ai-intent
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntent
   * @summary List intent entries
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/intent
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntent = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultIntent,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntent */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent`, query);

  /**
   * @description Creates a new intent entry
   *
   * @tags piper-ai-intent
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntent
   * @summary Create new intent
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/intent
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntent = (
    tenantId: string,
    workspaceId: string,
    data: IntentForm,
    params: RequestParams = {},
  ) =>
    this.request<
      Intent,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntent */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiIntentPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/intent`);

  /**
   * @description Creates a new knowledge base entry by providing a link and metadata.
   *
   * @tags piper-ai-knowledge-base
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseLink
   * @summary Create knowledge entry via link
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/knowledge-base/link
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseLink = (
    tenantId: string,
    workspaceId: string,
    data: KnowledgeEntryViaLinkForm,
    params: RequestParams = {},
  ) =>
    this.request<
      KnowledgeBaseEntryInProcessing,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseLink */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseLinkPathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/link`);

  /**
   * @description Creates a new knowledge base entry by uploading a file.
   *
   * @tags piper-ai-knowledge-base
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseFile
   * @summary Create knowledge entry via file upload
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/knowledge-base/file
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseFile = (
    tenantId: string,
    workspaceId: string,
    data: {
      /** @format binary */
      file: Record<string, any>;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      KnowledgeBaseEntryInProcessing,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/file`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseFile */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseFilePathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/file`);

  /**
   * @description Retrieves the processing status of a knowledge base entry by its ID.
   *
   * @tags piper-ai-knowledge-base
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidProcessingStatus
   * @summary Get knowledge entry processing status
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/knowledge-base/{knowledgeEntryId}/processing-status
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidProcessingStatus = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      KnowledgeEntryImportStatus,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}/processing-status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidProcessingStatus */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidProcessingStatusPathGetter = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}/processing-status`,
    );

  /**
   * @description Retrieves a knowledge base entry by its ID.
   *
   * @tags piper-ai-knowledge-base
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryid
   * @summary Get knowledge entry by ID
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/knowledge-base/{knowledgeEntryId}
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryid = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      KnowledgeBaseEntry,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryid */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidPathGetter = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}`);

  /**
   * @description Deletes a knowledge base entry by its ID.
   *
   * @tags piper-ai-knowledge-base
   * @name DeleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryid
   * @summary Delete knowledge entry by ID
   * @request DELETE:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/knowledge-base/{knowledgeEntryId}
   * @secure
   */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryid = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryid */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidPathGetter = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}`);

  /**
   * @description Retrieves a rendered knowledge base entry by its ID.
   *
   * @tags piper-ai-knowledge-base
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidRendered
   * @summary Get knowledge entry by ID
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/knowledge-base/{knowledgeEntryId}/rendered
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidRendered = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      RenderedKnowledgeEntry,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}/rendered`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidRendered */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBaseKnowledgeentryidRenderedPathGetter = (
    tenantId: string,
    workspaceId: string,
    knowledgeEntryId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base/${knowledgeEntryId}/rendered`,
    );

  /**
   * @description Returns a paginated list of knowledge base entries for the workspace.
   *
   * @tags piper-ai-knowledge-base
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBase
   * @summary List knowledge entries
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/knowledge-base
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBase = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultKnowledgeBaseEntry,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBase */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiKnowledgeBasePathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/knowledge-base`, query);

  /**
   * @description Get messages in a specific testing session
   *
   * @tags piper-ai-testing
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionid
   * @summary Get messages in testing session
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing/{testingSessionId}
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionid = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      TestingSession,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionid */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidPathGetter = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}`);

  /**
   * @description Deletes a specific testing session by its ID
   *
   * @tags piper-ai-testing
   * @name DeleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionid
   * @summary Delete a testing session
   * @request DELETE:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing/{testingSessionId}
   * @secure
   */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionid = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionid */
  deleteApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidPathGetter = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}`);

  /**
   * @description Returns a paginated list of rated responses
   *
   * @tags piper-ai-testing
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTesting
   * @summary List rated responses
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTesting = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTestingSession,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTesting */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing`, query);

  /**
   * @description Creates a new testing session
   *
   * @tags piper-ai-testing
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTesting
   * @summary Creates a new testing session
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTesting = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      TestingSession,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTesting */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing`);

  /**
   * @description Sends a question to the testing session
   *
   * @tags piper-ai-testing
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateQuestion
   * @summary Send a test question
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing/{testingSessionId}/state/question
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateQuestion = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
    data: TestMessageForm,
    params: RequestParams = {},
  ) =>
    this.request<
      TestingSession,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/state/question`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateQuestion */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateQuestionPathGetter = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/state/question`,
    );

  /**
   * @description Upserts a rating for a response in the testing session
   *
   * @tags piper-ai-testing
   * @name PutApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateRating
   * @summary Upserts a test response rating
   * @request PUT:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing/{testingSessionId}/state/rating
   * @secure
   */
  putApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateRating = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
    data: TestResponseRatingForm,
    params: RequestParams = {},
  ) =>
    this.request<
      TestingSession,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/state/rating`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for putApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateRating */
  putApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidStateRatingPathGetter = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/state/rating`,
    );

  /**
   * @description Repeat a question for Piper for the selected testing session, removing previous responses and ratings
   *
   * @tags piper-ai-testing
   * @name PostApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidRepeat
   * @summary Repeat a question for Piper AI for the selected testing session
   * @request POST:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing/{testingSessionId}/repeat
   * @secure
   */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidRepeat = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      TestingSession,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/repeat`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidRepeat */
  postApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidRepeatPathGetter = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/repeat`);

  /**
   * @description Get configuration resolved for a specific testing session
   *
   * @tags piper-ai-testing
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidInspect
   * @summary Get configuration resolved for a specific testing session
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing/{testingSessionId}/inspect
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidInspect = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      ResolvedMessageConfig[],
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/inspect`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidInspect */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingTestingsessionidInspectPathGetter = (
    tenantId: string,
    workspaceId: string,
    testingSessionId: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/${testingSessionId}/inspect`,
    );

  /**
   * @description Get hints for improving piper AI responses
   *
   * @tags piper-ai-testing
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingHints
   * @summary Get hints for improving piper AI responses
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/testing/hints
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingHints = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      ImprovementHint[],
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/hints`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingHints */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiTestingHintsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/testing/hints`);

  /**
   * @description Get statistics about Piper AI responses quality in a specific workspace
   *
   * @tags piper-ai-testing
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiStatistics
   * @summary Get Piper AI statistics for a workspace
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/statistics
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiStatistics = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PiperAiStatistics,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/statistics`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiStatistics */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiStatisticsPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/statistics`);

  /**
   * @description Retrieves the personality settings for a specific workspace
   *
   * @tags piper-ai-personality-settings
   * @name GetApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettings
   * @summary Get workspace personality settings
   * @request GET:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/personality-settings
   * @secure
   */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettings = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PersonalitySettingsView,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/personality-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettings */
  getApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettingsPathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/personality-settings`);

  /**
   * @description Updates the personality settings for a specific workspace
   *
   * @tags piper-ai-personality-settings
   * @name PatchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettings
   * @summary Patch workspace personality settings
   * @request PATCH:/v1/tenant/{tenantId}/workspaces/{workspaceId}/piper/ai/personality-settings
   * @secure
   */
  patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettings = (
    tenantId: string,
    workspaceId: string,
    data: PersonalitySettingsPatch,
    params: RequestParams = {},
  ) =>
    this.request<
      PersonalitySettings,
      | GuidanceId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/personality-settings`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettings */
  patchApiV1TenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettingsPathGetter = (
    tenantId: string,
    workspaceId: string,
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/${workspaceId}/piper/ai/personality-settings`);
}
